module.exports = __webpack_public_path__ + "img/35_25.659906fa.png";